var _title, _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelpLine = function SvgHelpLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "help2")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.563 23.656c0 0.863-0.7 1.563-1.563 1.563s-1.563-0.7-1.563-1.563c0-0.863 0.7-1.563 1.563-1.563s1.563 0.7 1.563 1.563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.843 0-16 7.156-16 16 0 8.843 7.156 16 16 16 8.843 0 16-7.156 16-16 0-8.843-7.156-16-16-16zM16 29.5c-7.461 0-13.5-6.038-13.5-13.5 0-7.461 6.038-13.5 13.5-13.5 7.461 0 13.5 6.038 13.5 13.5 0 7.461-6.038 13.5-13.5 13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.031c-2.757 0-5 2.243-5 5 0 0.69 0.56 1.25 1.25 1.25s1.25-0.56 1.25-1.25c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.379-1.122 2.5-2.5 2.5-0.69 0-1.25 0.56-1.25 1.25v3.125c0 0.69 0.56 1.25 1.25 1.25s1.25-0.56 1.25-1.25v-2.033c2.154-0.556 3.75-2.516 3.75-4.842 0-2.757-2.243-5-5-5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-line.30ba351d.svg";
export { ForwardRef as ReactComponent };